import styled from 'styled-components';

const InYourAreaHolder = styled.div`

.home__container {
	.inyour-area-title {
		font-size: 18px;
		text-align: center;
		margin-top: 40px;
		text-transform: uppercase;
		font-family: "Quicksand", sans-serif;
		font-weight: 500;
		line-height: 1.2;
		color: inherit;
	}
	.inyour-area-bar {
		.cpac-area-input {
			@media (max-width: 1200px) {
				font-size: 0.9rem;
			}
		}
	}
}
.inYourArea__container {
	.entry-title {
		font-size: 24px;
		text-align: left;
		width: 100%;
		height: 50px;
		color: #fdfdfc;
		background-color: #726b55;
		padding: 12px;
		margin: 0;
		font-family: "Quicksand", sans-serif;
		font-weight: 700;
		line-height: 1.2;
	}
	.inyour-area-bar {
		max-width: 576px;
		margin: 40px auto 20px;
		padding: 0 12px;
		   @media screen and (max-width: 767px) {
			padding: 0px;
		   }
		button { 
			right: 20px;
		}
	}
}
.inyour-area-bar {
	display:grid;
	grid-template-columns: 1fr;
	grid-gap: 5px;
	position: relative;
	.cpac-area-input {
		border-color: #d1cdc1;
		color: #97a7b5;
		width: 100%;
		text-align: left;
		height: 46px;
		padding: 4px 40px 4px 10px;
		border-radius: 2em;
		transition: all 0.2s ease-in;
		vertical-align: middle;
		margin: 25px auto 0px;
		display: inline-block;
		background-color: white;
		border: 1px solid #a9b2b1;
		outline: 0;
		font-size: 1.2rem;
		&:focus {
			text-align: left;
		}

	}
	.btn-cityFind {
		padding: 4px 10px;
		font-size: 12px;
		text-transform: uppercase;
		color: #fdfdfc;
		background: #726b55;
		border: solid 5px #d1cdc1;
		transition: all 0.2s ease-in;
		position: absolute;
		top: 33px;
		right: 7px;
		border-radius: 2em;
		vertical-align: middle;
		line-height: 1.1;
		display: inline-block;
		font-weight: 700;
		letter-spacing: .025em;
		text-align: center;
		cursor: pointer;
		&:hover {
			background: #a69e87 ;
			border: solid 5px #a69e87;
			transition: all 0.2s ease-in;
		}
	}
}
.inyour-area-content {
	padding: 0 12px;
	position: relative;
	.inyour-area-page {
		max-width: 720px;
		margin: 40px auto;
		.sat-results {
			padding-top: 2rem;
			.channel-heading {
				padding: 0 2rem;
				font-weight: 700;
				color: #7a7652;
			}
		}
		.company-item {
			background-color: #fff;
			margin-top: 1rem;
			padding: 0rem 2rem;
			position: relative;
			overflow: auto;
			.company-name {
				font-family: "Quicksand", sans-serif;
				margin: 20px 0;
				color: #fdfdfc;
				background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
				background-size: auto 110%;
				padding: 8px 20px 8px 40px;
				width: 100%;
				border-radius: 2em;
				border: 0;
				text-transform: uppercase;
				font-size: 24px;
			}
			.channel-en,
			.channel-fr {
				width: 50%;
				float: left;
				color: #383838;
				font-weight: 700;
				@media (max-width: 767px) {
					width: 100%;
				}
				.inarea-text {
					font-style: italic;
					font-size: 120%;
					padding-left: 1rem;
					.inarea-channel {
						font-weight: 200;
						width: 8em;
						display: inline-block;
						float: right;
						text-align: center;
						padding-right: 1em;
						@media (max-width: 767px) {
							text-align: right;
							padding-right: 1em;
						}
					}
				}
			}
		}
		.inyour-area-community {
			padding: 1.5rem 2rem 0;
			color: #7a7652;
			.community-label {
				font-style: italic;
				font-size: 120%;
				font-weight: 700;
			}
			.community-name {
				font-size: 120%;
			}
		}
	}
}

`;

export default InYourAreaHolder;